import Axios from "axios";
// import {APMCResponse} from "../../pages/license-registration-form/index"

const base_Url = process.env.REACT_APP_BASE_URL ;
// const base_Url = "http://localhost:7089";



export function submitBasicDetails(values, token ,applicationId) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
  
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/trader/submit-basic-details?applicationId=${applicationId ? applicationId :""}`, values, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {


          if (error.response?.data) {
            const { error: errormsg = "Unknown error", field = null } = error.response.data;
        
            if (field) {
             
              return rej(`Duplicate entry for field: ${field}`);
            }
        
            return rej(errormsg);
          }
        
      
          return rej("Something went wrong");
        });
    });
  }


export function submitRepresentatives(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
 
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/trader/submit-reprensentative-guarantor-details`, values, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
          
        });
    });
  }


  export function submitFirmDetails(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
  
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/trader/submit-firm-reprensentative-details`, values, config)
        .then((response) => {
      
          return res(response.data);
        })
        .catch((error) => {
        
          const errormsg = error.response.data.error
     

          const match = errormsg.match(/`TraderApplication_(.*?)_key`/);
          if(match)
          {
        

            const uniqueField = match?.[1] || null;
            
            return rej(uniqueField)
          }
          else{
            return rej(errormsg)

          }
        });
    });
  }

  export function submitEnclosureFiles(formdata, token,docId) {
    let config = {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/trader/trader-docs-upload?docId=${docId ?docId :""}`, formdata, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
         
        });
    });
  }



  export function getDocument(docId , token,type){
    let config = {
        headers: {
          Authorization: token,
        },
      };
 

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/trader/get-document/${docId}/${type}` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
           
        })
    })
  }

   export function getDocumentApmc(docId , token,type){
    let config = {
        headers: {
          Authorization: token,
        },
      };
   

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/apmc/get-application-detail-by-dataId/${docId}/${type}` , config)
        .then((response)=>{
            
            return res(response.data)
        })
        .catch((error)=>{
          
        })
    })
  }

  export function getAllDocument(applicationId ,pageNumber , token , type){
    let config = {
        headers: {
          Authorization: token,
        },
      };
      const typeParam = type==="gca"? "gca" : "trader"

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/${typeParam}/get-all-documents/${applicationId}/${type}?page=${pageNumber}&limit=2` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
          
        })
    })
  }

  export function getOneApplicationDetail(applicatioId ,  token){
    let config = {
        headers: {
          Authorization: token,
        },
      };
  

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/trader/get-one-trader-application/${applicatioId}` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
            
        })
    })
  }
  
  export function getApplications(status , token , page, search, limit, role){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/trader/get-all-trader-application/${status}?search=${search}&page=${page}&limit=${limit}&isGCA=${role == "GCA"}` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
         
        })
    })
  }

  export function getApplicationButtons(applicatioId ,  token){
    let config = {
        headers: {
          Authorization: token,
        },
      };
    

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/trader/get-trader-applicatio-buttons/${applicatioId}` , config)
        .then((response)=>{
            
            return res(response.data)
        })
        .catch((error)=>{
            
        })
    })
  }

  export function submitApproveRejectApplication(formdata, token) {
    let config = {
      headers: {
        Authorization: token,
   
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/trader/approve-reject-trader-application`, formdata, config)
        .then((response) => {
       
          return res(response.data);
        })
        .catch((error) => {
          
        });
    });
  }

  export function submitPanelApproveRejectApplication(formdata, token) {
    let config = {
      headers: {
        Authorization: token,
   
      },
    };
 
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/panel/approve-reject-panel-application`, formdata, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
         
        });
    });
  }

  export function getDraftApplication(token ){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/trader/get-draft-application` , config)
        .then((response)=>{
          
            return res(response.data)
        })
        .catch((error)=>{
        
        })
    })
  }

  export function getPanelDraftApplication(token ){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/panel/get-draft-application` , config)
        .then((response)=>{
            
            return res(response.data)
        })
        .catch((error)=>{
          
        })
    })
  }

  export function submitWorkExperienceforPanel(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
 
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/panel/submit-work-experience-detail`, values, config)
        .then((response) => {
         
          return res(response.data);
        })
        .catch((error) => {
      
        });
    });
  }

  export function submitBasicDetailsforPanel(values, token , applicationId) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
    
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/panel/submit-basic-details?applicationId=${applicationId}`, values, config)
        .then((response) => {
         
          return res(response.data);
        })
        .catch((error) => {
          
        });
    });
  }

  export function submitEducationDetailsforPanel(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
   
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/panel/submit-education-detail`, values, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
          
        });
    });
  }

  
  export function submitWorkExperiencePanel(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/panel/submit-work-experience-detail`, values, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
         
        });
    });
  }


  
  export function getDownloadLicense(token , applicationId){
    let config = {
        headers: {
          Authorization: token,
        },
        responseType: "blob",
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/trader/license-download/${applicationId}` , config)
        .then((response)=>{
            

            return res(response)
        })
        .catch((error)=>{
           
            rej(error);
        })
    })
  }
 export function getGCADownloadLicense(token , applicationId){
    let config = {
        headers: {
          Authorization: token,
        },
        responseType: "blob",
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/gca/license-download/${applicationId}` , config)
        .then((response)=>{
       

            return res(response.data)
        })
        .catch((error)=>{
            
            rej(error);
        })
    })
  }
  export function initiatePayment(values, token) {
 
    const config = {
      headers: {
        Authorization: token, // Add 'Bearer' if required
      },
      responseType: 'blob', // Handle HTML as a binary file
    };
    
    
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/payments/initiate-transaction`, values, config)
        .then((response) => {
         
          if(response.status==200)
          return res(response);
        })
        .catch((error) => {
       
        });
    });
  }

  export function getOrderTransaction(applicationId , orderID , token){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.post(`${base_Url}/payments/getOrder` , {applicationId, orderID},config)
        .then((response)=>{
            
            return res(response.data)
        })
        .catch((error)=>{
           
        })
    })
  }

  export function getOrderTransactionGca(applicationId , orderID , token){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.post(`${base_Url}/paymentGca/getOrder` , {applicationId, orderID},config)
        .then((response)=>{
          
            return res(response.data)
        })
        .catch((error)=>{
            
        })
    })
  }

  


  export function submitEnclouser(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/trader/enclouser-submit`, values, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
    
        });
    });
  }

  export function getPanelApplications(status , token , page, search, limit){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/panel/get-all-panel-application/${status}?search=${search}&page=${page}&limit=${limit}` , config)
        .then((response)=>{
          
            return res(response.data)
        })
        .catch((error)=>{
           
        })
    })
  }

  export function getOnePanelApplicationDetail(applicatioId ,  token){
    let config = {
        headers: {
          Authorization: token,
        },
      };
   

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/panel/get-one-panel-application/${applicatioId}` , config)
        .then((response)=>{
            
            return res(response.data)
        })
        .catch((error)=>{
        
        })
    })
  }

  export function getApplicationExistencCheck(token){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/trader/apply-new-application` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
            
        })
    })
  }


  export function submitDeclarationPanel(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
   
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/panel/submit-application`, {applicationId:values}, config)
        .then((response) => {
         
          return res(response.data);
        })
        .catch((error) => {
          
        });
    });
  }

  export function deleteDocument(body , token){
    let config = {
        headers: {
          Authorization: token,
        },
      };


    return new Promise((res , rej)=>{
        Axios.post(`${base_Url}/common/delete-row-and-child`, body , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
            
        })
    })
  }

  export function editBorderDistrict(body , token , applicationId){
    let config = {
        headers: {
          Authorization: token,
        },
      };
  

    return new Promise((res , rej)=>{
        Axios.post(`${base_Url}/panel/update-borderDistrict?applicationId=${applicationId}`, body , config)
        .then((response)=>{
            
            return res(response.data)
        })
        .catch((error)=>{
          
        })
    })
  }

  export function licenseQR(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
   
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/common/generate-QR`, values, config)
        .then((response) => {
          // const imageUrl = URL.createObjectURL(response.data);
          return res(response.data);
        })
        .catch((error) => {
         
          rej(error);
        });
    });
  }


    export function verifyCaptcha(recaptchaToken) {
 
    const body={
      recaptchaToken: recaptchaToken,
    }
    
   
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/common/verify-recaptcha`, body)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
  }


    export function getSSODetails(formdata, ssoGeneratedtoken) {
    let config = {
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${ssoGeneratedtoken}`,
        // 'Content-Type':'multipart/form-data'
      },
    };
    

    return new Promise((res, rej) => {
      Axios.post(`https://gujaratsso.gujarat.gov.in/gujaratssowebapi/VOne/SSOCAFDetails`, formdata, config)
        .then((response) => {
        
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
  }

    export function getSsoToken() {
  
 
    return new Promise((res, rej) => {
      Axios.get(`${base_Url}/user/generate-sso-token`)
        .then((response) => {
          // const imageUrl = URL.createObjectURL(response.data);
          return res(response.data);
        })
        .catch((error) => {
        
          rej(error);
        });
    });
  }

     export function resisterAndLogin(ssoEcryptres , userType) {
  
  
    const body = {
      ssoEncryptResult: ssoEcryptres,
      userType:userType
    }
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/user/sso-login-register` , body)
        .then((response) => {
          // const imageUrl = URL.createObjectURL(response.data);
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
  }

  export function getApmcByDepartmentId(token , depId) {
  
    
     let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.get(`${base_Url}/common/get-all-apmc?departmentId=${depId}` , config)
        .then((response) => {
          // const imageUrl = URL.createObjectURL(response.data);
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
  }

  //SSO DETAILS LOGIN 13-11-25

  export function getSSODetailsByLogin(token) {
 
    let config = {
        headers: {
          Authorization: token,
     
        },
      };
 
    return new Promise((res, rej) => {
      Axios.get(`${base_Url}/user/get-sso-user-details`, config)
        .then((response) => {
          // const imageUrl = URL.createObjectURL(response.data);
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
  }

   export function getApmcSchemes( ) {
    return new Promise((res, rej) => {
      Axios.get(`${base_Url}/apmc/get-scheme?type=scheme` ,)
        .then((response) => {
          return res(response.data);
        })
        .catch((error) => {
         
          rej(error);
        });
    });
  }
  export function getApmcPurposes(scheme) {
    return new Promise((res, rej) => {
      Axios.get(`${base_Url}/apmc/get-scheme?scheme=${scheme}` ,)
        .then((response) => {
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
  }

  export function getYardsAPMC(token){
  let config={
    headers:{
      Authorization:token,
    },
  };

  return new Promise((res, rej)=>{
    Axios.get(`${base_Url}/apmc/get-all-yards-subYards`, config)
    .then((response)=>{
      return res(response?.data)
    })
    .catch((error)=>{
      return res(error)
    })
  })
}

   export function submitApmcFiles(formdata,token,docId) {
     let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/docs-upload?docId=${docId}` ,formdata,config)
        .then((response) => {
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
  }
    export function applyNewApmcApplication(id,token,applicationType
 ) {
    
      
     let config = {
      headers: {
        Authorization: token,
    
      },
    };
    applicationType= applicationType==="form" ? "form" : "scheme"
    const formdata= applicationType==="form"? {
        schemeId:String(id)
      }:
      id
      
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/apply-new-apmc-application?applicationType=${applicationType}` ,formdata,config)
        .then((response) => {
       
          return res(response.data);
        })
        .catch((error) => {
       
          rej(error);
        });
    });

  }
   export function applyNewFormApmcApplication(scheme,token) {
      
  
     let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.get(`${base_Url}/apmc/get-form?type=form` ,config)
        .then((response) => {
       
          return res(response.data);
        })
        .catch((error) => {
        
          rej(error);
        });
    });

  }


export function getApmcApplicationDetails(   status,
        token,
        page,
        searchApplicationById,
        limit , type) {
  const config = {
    headers: {
      Authorization: token,
    },
   
  };

  return new Promise((res, rej) => {
    Axios.get(`${base_Url}/apmc/get-application-detail/${status}?search=${searchApplicationById}&limit=${limit}&page=${page}&type=${type}`, config)
      .then((response) => res(response.data))
      .catch((error) => rej(error));
  });
}


    export function submitAnnexureOne(formdata,token,applicationId) {
    let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/submit-scheme-annexureOne?applicationId=${applicationId}` ,formdata,config)
        .then((response) => {
     
          return res(response.data);
        })
        .catch((error) => {
         
          rej(error);
        });
    });
}
     export function submitAnnexureTwo(formdata,token,applicationId) {
    let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/submit-scheme-annexureTwo?applicationId=${applicationId}` ,formdata,config)
        .then((response) => {
      
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
}
      export function submitAnnexureThree(formdata,token,applicationId) {
    let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/submit-scheme-annexureThree?applicationId=${applicationId}` ,formdata,config)
        .then((response) => {
         
          return res(response.data);
        })
        .catch((error) => {
       
          rej(error);
        });
    });
}
       export function getExistedSchemesAplication(token,applicationId,schemeId) {
    let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.get(`${base_Url}/apmc/get-one-trader-application/${applicationId}/${schemeId}`,config)
        .then((response) => {
         
          return res(response.data);
        })
        .catch((error) => {
         
          rej(error);
        });
    });
  }

    export function updateField(body,token) {
    let config = {
      headers: {
        Authorization: token,
    
      },
    };
  
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/scheme-fields-transaction` ,body,config)
        .then((response) => {
         
          return res(response.data);
        })
        .catch((error) => {
         
          rej(error);
        });
    });
}

 export function submitApmcApproveRejectApplication(formdata, token) {
    let config = {
      headers: {
        Authorization: token,
   
      },
    };
 
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/approve-reject-apmc-application`, formdata, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
         
        });
    });
  }

   export function submitAnnexureOnePointOneForm( token , formdata) {
    let config = {
      headers: {
        Authorization: token,
   
      },
    };
  
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/dr-form-submission`, formdata, config)
        .then((response) => {
        
          return res(response.data);
        })
        .catch((error) => {
         
        });
    });
  }
  
  

  export function submitForms(formdata,token,applicationId) {
    let config = {
      headers: {
        Authorization: token,
   
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/submit-form-first-docs?applicationId=${applicationId}` ,formdata,config)
        .then((response) => {
      
          return res(response.data);
        })
        .catch((error) => {
        
          rej(error);
        });
    });
}
     export function submitAnnexureUpdate(formdata,token) {
    let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc/scheme-form-insertByDepartment` ,formdata,config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
          
          rej(error);
        });
    });
}

//gca api calling
  export function getGcaApplicationExistencCheck(token){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/gca/apply-new-application` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
           
        })
    })
  }

  export function submitGcaBasicDetails(values, token ,applicationId) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
    
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/gca/submit-basic-details?applicationId=${applicationId ? applicationId :""}`, values, config)
        .then((response) => {
        
          return res(response.data);
        })
        .catch((error) => {
       

          if (error.response?.data) {
            const { error: errormsg = "Unknown error", field = null } = error.response.data;
        
            if (field) {
             
              return rej(`Duplicate entry for field: ${field}`);
            }
        
            return rej(errormsg);
          }
        
         
          return rej("Something went wrong");
        });
    });
  }
  export function submitGcaRepresentatives(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
 
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/gca/submit-reprensentative-guarantor-details`, values, config)
        .then((response) => {
         
          return res(response.data);
        })
        .catch((error) => {
        
        });
    });
  }
    export function submitGcaEnclosureFiles(formdata, token,docId) {
    let config = {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/gca/gca-docs-upload?docId=${docId ?docId :""}`, formdata, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
         
        });
    });
  }
    export function getOneGcaApplicationDetail(applicatioId ,  token){
    let config = {
        headers: {
          Authorization: token,
        },
      };
    

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/gca/get-one-gca-application/${applicatioId}` , config)
        .then((response)=>{
        
            return res(response.data)
        })
        .catch((error)=>{
            
        })
    })
  }
    export function submitGcaApproveRejectApplication(formdata, token) {
    let config = {
      headers: {
        Authorization: token,
   
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/gca/approve-reject-gca-application`, formdata, config)
        .then((response) => {
      
          return res(response.data);
        })
        .catch((error) => {
    
        });
    });
  }
   export function getAllApmcDocument(applicationId, token, type) {
    let config = {
      headers: {
        Authorization: token,
      },
      responseType: "arraybuffer", // 👈 Important for binary data
    };
  
    return Axios.get(
      `${base_Url}/apmc/get-all-documents/${applicationId}/${type}`,
      config
    )
      .then((response) => {
        return response.data; // this will now be an ArrayBuffer
      })
      .catch((error) => {
       
        throw error;
      });
  }

   export function getGcaApplications(status , token , page, search, limit, roleIdentifier){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/gca/get-all-gca-application/${status}?search=${search}&page=${page}&limit=${limit}&isTrader=${roleIdentifier=="Tr"}` , config)
        .then((response)=>{
         
            return res(response.data)
        })
        .catch((error)=>{
           
        })
    })
  }
    export function getGcaDraftApplication(token ){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/gca/get-draft-application` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
           
        })
    })
  }
    export function submitGcaFirmDetails(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };
   
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/gca/submit-firm-reprensentative-details`, values, config)
        .then((response) => {
         
          return res(response.data);
        })
        .catch((error) => {
         
          const errormsg = error.response.data.error
         

          const match = errormsg.match(/`TraderApplication_(.*?)_key`/);
          if(match)
          {
        

            const uniqueField = match?.[1] || null;
           
            return rej(uniqueField)
          }
          else{
            return rej(errormsg)

          }
        });
    });
  }
   export function submitGcaEnclouser(values, token) {
    let config = {
      headers: {
        Authorization: token,
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/gca/enclouser-submit`, values, config)
        .then((response) => {
        
          return res(response.data);
        })
        .catch((error) => {

        });
    });
  }
    export function initiateGcaPayment(values, token) {
  
    const config = {
      headers: {
        Authorization: token, // Add 'Bearer' if required
      },
      // responseType: 'blob', // Handle HTML as a binary file
    };
    
 
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/paymentGca/initiate-transaction`, values, config)
        .then((response) => {
        
          if(response.status==200)
          return res(response);
        })
        .catch((error) => {
     
        });
    });
  }

      export function initiateCFPayment(values, token) {

    const config = {
      headers: {
        Authorization: token, // Add 'Bearer' if required
      },
      responseType: 'blob', // Handle HTML as a binary file
    };
    
 
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/paymentcf/initiate-transaction`, values, config)
        .then((response) => {
        
          if(response.status==200)
          return res(response);
        })
        .catch((error) => {
      
        });
    });
  }

export function getgcaDocument(docId , token,type){
    let config = {
        headers: {
          Authorization: token,
        },
      };
   

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/gca/get-document/${docId}/${type}` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
          
        })
    })
  }
 
export function queryApplication(values, token) {
  let config = {
    headers: {
      Authorization: token,
    },
  };

  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/apmc/approve-reject-apmc-application`, values, config)
      .then((response) => 
        res(response.data)
    )
      .catch((error) => 
        rej(error.response ? error.response.data : error)
    );
  });
}
export function queryFormApplication(values, token) {
  let config = {
    headers: {
      Authorization: token,
    },
  };

  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/apmc/standard-fields-transaction`, values, config)
      .then((response) => 
        res(response.data)
    )
      .catch((error) => 
        rej(error.response ? error.response.data : error)
    );
  });
}

//Contract Farming
export function alreadyRegApplication(token) {
  let config = {
    headers: {
      Authorization: token,
    },
  };

  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/contract_farming/apply-new-form-application`,{} ,config)
      .then((response) => 
        res(response.data)
    )
      .catch((error) => 
        rej(error.response ? error.response.data : error)
    );
  });
}

  export function submitContractFarmingFiles(formdata, token,docId) {
    let config = {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
    };
   
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/contract_farming/docs-upload?docId=${docId ?docId :""}`, formdata, config)
        .then((response) => {
          
          return res(response.data);
        })
        .catch((error) => {
         
        });
    });
  }
  export async function submitContractFarmingFilesAgreement(formdata, token,docId) {
    let config = {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
    };
    
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/contract_farming/docs-upload-agreement?docId=${docId ?docId :""}`, formdata, config)
        .then((response) => {
          return res(response.data);
        })
        .catch((error) => {
          return error;
        });
    });
    
      // try {
      //   const response = await Axios.post(`${base_Url}/contract_farming/docs-upload-agreement?docId=${docId ?docId :""}`, formdata, config);
      //   return response?.data;
      // }catch(err){
      //   return err;
      // }
  }
  
  export function SponsorRegistration(formData,applicationId,token) {
  let config = {
    headers: {
      Authorization: token,
    },
  };

  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/contract_farming/submit-form-details?applicationId=${applicationId}`,formData ,config)
      .then((response) => 
        res(response.data)
    )
      .catch((error) => 
        rej(error.response ? error.response.data : error)
    );
  });
}
  export function apmcByDistrictId(formData,token) {
  let config = {
    headers: {
      Authorization: token,
    },
  };

  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/contract_farming/get-apmc-by-district-ids`,formData ,config)
      .then((response) => 
        res(response.data)
    )
      .catch((error) => 
        rej(error.response ? error.response.data : error)
    );
  });
}

  export function getAllSpices(token){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/contract_farming/get-all-spices` , config)
        .then((response)=>{
          
            return res(response.data)
        })
        .catch((error)=>{
           
        })
    })
  }

    export function getOneContractFarmingDetails(applicationId ,  token){
    let config = {
        headers: {
          Authorization: token,
        },
      };


    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/contract_farming/get-one-cf-application/${applicationId}` , config)
        .then((response)=>{
          
            return res(response.data)
        })
        .catch((error)=>{
         
        })
    })
  }

  export function getCFDetails(appStatusLevel, token) {
  const config = {
    headers: {
      Authorization: token,
    },
   
  };

  return new Promise((res, rej) => {
    Axios.get(`${base_Url}/contract_farming/get-application-detail/${appStatusLevel}`, config)
      .then((response) => res(response.data))
      .catch((error) => rej(error));
  });
}

   export function getDocumentContractfarming(docId , token){
    let config = {
        headers: {
          Authorization: token,
        },
      };
  

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/contract_farming/get-doc-preview/${docId}` , config)
        .then((response)=>{
           
            return res(response.data)
        })
        .catch((error)=>{
           
        })
    })
  }

    export function approveRejectContactFarming(formData,token) {
  let config = {
    headers: {
      Authorization: token,
    },
  };

  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/contract_farming/approve-reject-cf-application`,formData ,config)
      .then((response) => 
        res(response.data)
    )
      .catch((error) => 
        rej(error.response ? error.response.data : error)
    );
  });
}
    export function approveRejectContactFarmingAgreement(formData,token) {
  let config = {
    headers: {
      Authorization: token,
    },
  };

  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/contract_farming/approve-reject-agreement-application`,formData ,config)
      .then((response) => 
        res(response.data)
    )
      .catch((error) => 
        rej(error.response ? error.response.data : error)
    );
  });
}

  export async function getCFStampDOC(docId, token){
    let config = {
        headers: {
          Authorization: token,
        },
      };

    return new Promise((res , rej)=>{
        Axios.get(`${base_Url}/contract_farming/get-doc-agg-preview/${docId}`, config)
        .then((response)=>{
            return res(response.data)
        })
        .catch((error)=>{
        })
    })
      // try {
      //   const response = await Axios.get(`${base_Url}/contract_farming/get-doc-preview/${docId}` , config);
      //   return response?.data;
      // } catch(err){
      //   return err;
      // }
  }
  
export function getAllApplicationCounts(token){
  let config = {
      headers: {
        Authorization: token,
      },
    };

  return new Promise((res , rej)=>{
      Axios.get(`${base_Url}/common/get-all-application-counts` , config)
      .then((response)=>{
        
          return res(response?.data)
      })
      .catch((error)=>{
        
          return res(error)
      })
  })
}

// MIS

export function getMISheaders(token){
  let config={
    headers:{
      Authorization:token,
    },
  };

  return new Promise((res, rej)=>{
    Axios.get(`${base_Url}/mis-dashboard/get-headers-details`, config)
    .then((response)=>{
      return res(response?.data)
    })
    .catch((error)=>{
      return res(error)
    })
  })
}
export function getMIShtmlExcel(token,month,year,headerId){
  let config={
    headers:{
      Authorization:token,
    },
  };

  return new Promise((res, rej)=>{
    Axios.get(`${base_Url}/mis-dashboard/get-uploaded-html-data?&headerId=${headerId}&month=${month}&year=${year}`, config)
    .then((response)=>{
      return res(response?.data)
    })
    .catch((error)=>{
      return res(error)
    })
  })
}

//   export function uploadMISDocXL(formData,token) {
//     let config = {
//       headers: {
//         Authorization: token,
//       },
//     };

//   return new Promise((res, rej) => {
//     Axios.post(`${base_Url}/mis-dashboard/upload-mis-data`,formData ,config)
//       .then((response) => 
//         res(response.data)
//     )
//       .catch((error) => 
//         rej(error.response ? error.response.data : error)
//     );
//   });
// }


export async function uploadMISDocXL(token, month, year, header_id, status, file) {
    try {
        // Create FormData and append all fields
        const formData = new FormData();
        formData.append("month", month);
        formData.append("year", year);
        formData.append("header_id", header_id);
        formData.append("status", status);
        formData.append("file", file); 

        // Configuration with Authorization header
        const config = {
            headers: {
                Authorization: token,
                "Content-Type": "multipart/form-data"
            },
        };

        const response = await Axios.post(
            `${base_Url}/mis-dashboard/upload-mis-data`,
            formData,
            config
        );

        if (!response.data) {
            throw new Error("No data received from server.");
        }

        return response.data;
    } catch (error) {
        
        throw error;
    }
}

export function applynewMisApplication(token,data){
  let config={
    headers:{
      Authorization:token,
    },
  };

  return new Promise((res, rej)=>{
    Axios.post(`${base_Url}/mis-dashboard/apply-new-mis-app`,data, config)
    .then((response)=>{
      return res(response?.data)
    })
    .catch((error)=>{
      return res(error)
    })
  })
}
export function submitMisApplication(token,data){
  let config={
    headers:{
      Authorization:token,
    },
  };

  return new Promise((res, rej)=>{
    Axios.post(`${base_Url}/mis-dashboard/create-entry-in-forms`,data, config)
    .then((response)=>{
      return res(response?.data)
    })
    .catch((error)=>{
      return res(error)
    })
  })
}

  export function getMISApplicationsDetails(headerId,limit,page,status, token) {
  const config = {
    headers: {
      Authorization: token,
    },
   
  };

  return new Promise((res, rej) => {
    Axios.get(`${base_Url}/mis-dashboard/get-all-mis-application/${status}?headerId=${headerId}&limit=${limit}&page=${page}`, config)
      .then((response) => res(response.data))
      .catch((error) => rej(error));
  });
}

export function getOneMISApplicationDetails(applicationId, headerId, token) {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  return Axios.get(
    `${base_Url}/mis-dashboard/get-one-mis-application/${applicationId}/${headerId}`,
    config
  )
    .then((response) => response.data) 
    .catch((error) => {
      
      throw error; 
    });
}
export function getAllFiltersInMISAfterApproval(districtId, headerId, page, limit, fromDate, toDate, token,apmcName) {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  return Axios.get(
    `${base_Url}/mis-dashboard/mis-dashboard-by-headerId/?apmcName=${apmcName}&districtId=${districtId}&limit=${limit}&page=${page}&headerId=${headerId}&fromDate=${fromDate}&toDate=${toDate}`,
    config
  )
    .then((response) => response.data) 
    .catch((error) => {
    
      throw error; 
    });
}


  export function submitApproveRejectMISApplication(formdata, token) {
    let config = {
      headers: {
        Authorization: token,
   
      },
    };
 
    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/mis-dashboard/approve-reject-mis-application`, formdata, config)
        .then((response) => {
       
          return res(response.data);
        })
        .catch((error) => {
       
        });
    });
  }

  export function getMISAllAppFilled(token){
  let config={
    headers:{
      Authorization:token,
    },
  };

  return new Promise((res, rej)=>{
    Axios.get(`${base_Url}/mis-dashboard/get-notification-data`, config)
    .then((response)=>{
      return res(response?.data)
    })
    .catch((error)=>{
      return res(error)
    })
  })
}

export function getAllAppliedMISHeaders(token,limit){
  let config={
    headers:{
      Authorization:token,
    },
  };

  return new Promise((res, rej)=>{
    Axios.get(`${base_Url}/mis-dashboard/mis-report-filled-by-accountant/?limit=${limit}`, config)
    .then((response)=>{
      return res(response?.data)
    })
    .catch((error)=>{
      return res(error)
    })
  })
}

//apmc detail form 
 export function checkNewApmcDetailApplication(token) {
     let config = {
      headers: {
        Authorization: token,
    
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc-detail/apply-new-apmcDetail-application`,{},config)
        .then((response) => {
          return res(response.data);
        })
        .catch((error) => {
       
          rej(error);
        });
    });
  }

   export function newOneTimeDocUpload(token,formdata,docId) {
     let config = {
      headers: {
        Authorization: token,
 
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc-detail/docs-upload?docId=${docId}` ,formdata,config)
        .then((response) => {
          return res(response.data);
        })
        .catch((error) => {
      
          rej(error);
        });
    });
  }
   export function submitOneTimeAPMCForm(token,formdata,applicationId) {
     let config = {
      headers: {
        Authorization: token,
 
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc-detail/submit-apmc-detail-application?applicationId=${applicationId}` ,formdata,config)
        .then((response) => {
          return res(response.data);
        })
        .catch((error) => {
        
          rej(error);
        });
    });
  }
  export function getApmcOneTimeFormApplicationDetails(   status,
        token,
        page,
        searchApplicationById,
        limit ) {
  const config = {
    headers: {
      Authorization: token,
    },
   
  };

  return new Promise((res, rej) => {
    Axios.get(`${base_Url}/apmc-detail/get-apmc-detail-application/${status}?search=${searchApplicationById}&limit=${limit}&page=${page}`, config)
      .then((response) => res(response.data))
      .catch((error) => rej(error));
  });
}
  export function getApmcOneTimeFormApplicationDocs(  
        token,
        docId
        ) {
  const config = {
    headers: {
      Authorization: token,
    },
   
  };

  return new Promise((res, rej) => {
    Axios.get(`${base_Url}/apmc-detail/get-apmc-application-detail-by-dataId/${docId}`, config)
      .then((response) => res(response.data))
      .catch((error) => rej(error));
  });
}
  export function getApmcOneTimeFormOneApplicationDetails(  
        applicationId,
        token
        ) {
  const config = {
    headers: {
      Authorization: token,
    },
   
  };

  return new Promise((res, rej) => {
    Axios.get(`${base_Url}/apmc-detail/get-one-apmcdetail-application/${applicationId}`, config)
      .then((response) => res(response.data))
      .catch((error) => rej(error));
  });
}

  export function approveRejectApmcDetailApplication(token,formdata) {
     let config = {
      headers: {
        Authorization: token,
 
      },
    };

    return new Promise((res, rej) => {
      Axios.post(`${base_Url}/apmc-detail/approve-reject-apmc-detail-application` ,formdata,config)
        .then((response) => {
          return res(response.data);
        })
        .catch((error) => {
  
          rej(error);
        });
    });
  }
  

   export function getEsignVerification(  
        applicationId,
        applicationType,
        token
        ) {
  const config = {
    headers: {
      Authorization: token,
    },
   
  };

  return new Promise((res, rej) => {
    Axios.get(`${base_Url}/esign/start/${applicationId}/${applicationType}`, config)
      .then((response) => res(response.data))
      .catch((error) => rej(error));
  });
}